import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered fresh for 2 minutes — avoids redundant re-fetches on tab focus
      staleTime: 2 * 60 * 1000,
      // Keep unused cache entries for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry once on failure (not 3x — backend errors should surface quickly)
      retry: 1,
      // Don't re-fetch just because the user switched browser tabs
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
